import React, { FC, useState } from 'react';
import cx from 'classnames';
import { SidebarIcon } from '../Icons/SidebarIcon';
import { ChevronIcon } from '../Icons/ChevronIcon';

type TTerritorySidebarButtonProps = {
  onClick: () => void;
  isOpen?: boolean;
};

export const TerritorySidebarButton: FC<TTerritorySidebarButtonProps> = ({ onClick, isOpen }) => {
  const [onHover, setOnHover] = useState(false);
  const toggleHover = () => {
    setOnHover(!onHover);
  };

  return (
    <button
      className="p-[10px] border rounded-full border-t2-neutral-grey03"
      onClick={onClick}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
    >
      <div className="flex w-5 h-5 items-center justify-center">
        {!onHover && (
          <div className="stroke-t2-neutral-grey07">
            <SidebarIcon />
          </div>
        )}
        {onHover && (
          <div className={cx({ 'rotate-180': !isOpen })}>
            <ChevronIcon />
          </div>
        )}
      </div>
    </button>
  );
};
